import request from '@/sheep/request';

const PayWalletApi = {
  // 获取钱包
  getPayWallet() {
    return request({
      url: '/pay/wallet/get',
      method: 'GET',
      custom: {
        showLoading: false,
        auth: true,
      },
    });
  },
  // 获得钱包流水分页
  getWalletTransactionPage: (params) => {
    const queryString = Object.keys(params)
      .map((key) => encodeURIComponent(key) + '=' + params[key])
      .join('&');
    return request({
      url: `/pay/wallet-transaction/page?${queryString}`,
      method: 'GET',
    });
  },
  // 获得钱包流水统计
  getWalletTransactionSummary: (params) => {
    const queryString = `createTime=${params.createTime[0]}&createTime=${params.createTime[1]}`;
    return request({
      url: `/pay/wallet-transaction/get-summary?${queryString}`,
      // url: `/pay/wallet-transaction/get-summary`,
      method: 'GET',
      // params: params
    });
  },
  // 获得钱包充值套餐列表
  getWalletRechargePackageList: () => {
    return request({
      url: '/pay/wallet-recharge-package/list',
      method: 'GET',
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  hasDiscountPrivilege: (params) => {
    return request({
      url: '/pay/coupons-user/hasDiscountPrivilege',
      method: 'GET',
      params,
    });
  },
  // 创建钱包充值记录（发起充值）
  createWalletRecharge: (data) => {
    return request({
      url: '/pay/wallet-recharge/create',
      method: 'POST',
      data,
    });
  },
  // 获得钱包充值记录分页
  getWalletRechargePage: (params) => {
    return request({
      url: '/pay/wallet-recharge/page',
      method: 'GET',
      params,
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 判断是否绑定广职专区的卡
  isBindGuangZhiCard : () => {
    return request({
      url:'/pay/coupons-user/checkCard',
      method:'GET',
    })
  },

  // 获取会员充值权益
  getRechargeEquity: (params) => {
    return request({
      url: '/pay/recharge-equity/get',
      method: 'GET',
      params,
    });
  },

  // 获取有无充值权限
  getRechargeUser: (params) => {
    return request({
      url: '/pay/coupons-user/recharge',
      method: 'GET',
      params,
    });
  },
};

export default PayWalletApi;
